import React, { type FunctionComponent, useEffect, useState } from 'react'
import { CharitySearch } from './search/CharitySearch'
import { CharityActionList } from './CharityActionList'
import { PromotedCampaignsProvider } from './promoted/PromotedCampaignsProvider'
import { PromotedCampaigns } from './promoted/PromotedCampaigns'
import { Link, useSearchParams } from 'react-router-dom'
import { availableAppContexts, schemeMap } from '../common/charity'

export const CharitiesHomePage: FunctionComponent = () => {
  const [selectedAppContext, setSelectedAppContext] = useState<CharityAppContext>(availableAppContexts[0])
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (!searchParams.has('appContext')) {
      setSearchParams({ appContext: selectedAppContext })
    }
  }, [searchParams])

  return (
    <div className="p-lg grid grid-cols-12 gap-md">
      <h1 className="text-xl col-span-3 self-end">Charities</h1>

      <div className="flex space-x-md tabs col-span-5">
        {availableAppContexts.map(appContext => (
          <button
            key={`tab-${appContext}`}
            className={`tab text-base ${selectedAppContext === appContext ? 'active' : ''}`}
            onClick={() => {
              setSelectedAppContext(appContext)
              setSearchParams({ appContext })
            }}
          >
            {schemeMap[appContext]}
          </button>
        ))}
      </div>

      <div className="flex space-x-md mb-md items-end justify-end col-span-4 h-full">
        <Link to="/charities/list" className="link">
          View all charities
        </Link>
        <Link to="/campaigns/list" className="link">
          View all campaigns
        </Link>
        <Link to="/charities/report" className="link">
          Create reports
        </Link>
      </div>

      <div className="col-span-8 col-start-1">
        <CharityActionList appContext={selectedAppContext} />
      </div>

      <div className="col-span-4 col-start-9">
        <CharitySearch />

        <PromotedCampaignsProvider>
          <PromotedCampaigns appContext={selectedAppContext} />
        </PromotedCampaignsProvider>
      </div>
    </div>
  )
}
